/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* Generated Angular service for CallStatistic controller
* Do not edit this file manually
*/
import { HttpClient, HttpContext, HttpContextToken, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH_DEFAULT, CLIENT_CONTEXT_TOKEN_DEFAULT } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { RequestOptions, GetLiveCallStatisticsResponse, GetCallStatisticsResponse } from "../models";

@Injectable({ providedIn: "root" })
export class CallStatisticService {
    private readonly httpClient: HttpClient = inject(HttpClient);
    private readonly basePath: string = inject(BASE_PATH_DEFAULT);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_DEFAULT;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'default');
    }

    getLiveCallStatistics(observe?: 'body', options?: RequestOptions<'json'>): Observable<GetLiveCallStatisticsResponse>;
    getLiveCallStatistics(observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<GetLiveCallStatisticsResponse>>;
    getLiveCallStatistics(observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<GetLiveCallStatisticsResponse>>;
    getLiveCallStatistics(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/CallStatistic/live`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.get(url, requestOptions);
    }

    getCallStatistics(startDate: Date, endDate: Date, observe?: 'body', options?: RequestOptions<'json'>): Observable<GetCallStatisticsResponse>;
    getCallStatistics(startDate: Date, endDate: Date, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<GetCallStatisticsResponse>>;
    getCallStatistics(startDate: Date, endDate: Date, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<GetCallStatisticsResponse>>;
    getCallStatistics(startDate: Date, endDate: Date, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/CallStatistic`;

        let params = new HttpParams();
        if (startDate != null) {
            params = HttpParamsBuilder.addToHttpParams(params, startDate, 'startDate');
        }
        if (endDate != null) {
            params = HttpParamsBuilder.addToHttpParams(params, endDate, 'endDate');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.get(url, requestOptions);
    }
}
